import api from 'services/api';
import { User, UserResponse, UserInvitation, UserRole, RegisterUser, UserProfile } from 'models/users.model';
import { RegisterUserFormValuesType } from 'components/organisms/RegisterUserForm';

export const getUser = async (userId: string): Promise<UserResponse> => await api.get(`/users/${userId}`);

export const getProfileUser = async (): Promise<UserProfile> => {
  const { data } = await api.get('/users/current');
  return data;
};

export const getUserSearch = async (query: string): Promise<User[]> => {
  const params = new URLSearchParams();
  params.append('search', `${query}`);
  const response = await api.get('/users', {
    params,
  });
  return response.data;
};

export const getRoleUser = async (): Promise<UserRole[]> => {
  const { data } = await api.get('/users/roles');
  return data;
};

export const addUserAccessToAsset = async (userId: string, assetId: string): Promise<void> => {
  return await api.patch(`/users/${userId}/asset/${assetId}/relate`);
};

export const revokeUserAccessToAsset = async (userId: string, assetId: string): Promise<void> =>
  await api.request({
    method: 'delete',
    url: `/users/${userId}/relationships/assets`,
    data: {
      data: [{ id: assetId }],
    },
  });

export const deleteUser = async (userId: string): Promise<{ detail: string }> => await api.delete(`/users/${userId}`);

export const invitationUser = async (data: UserInvitation): Promise<void> => {
  await api.post('/users/register/invitation', {
    data,
  });
};

export const registerUser = async (values: RegisterUserFormValuesType): Promise<RegisterUser> => {
  const currentUrl: string = window.location.href;
  const url = new URL(currentUrl);
  const token = url.searchParams.get('token') || '';
  const data: RegisterUser = {
    name: values.name,
    email: values.email,
    password: values.password,
    cellphone: values.cellphone,
    terms_of_service: values.terms_of_service,
    token,
  };

  const response: RegisterUser = await api.post('/users/register/by_token', { data });
  return response;
};
